export default {
  "content": "<path fill=\"#D7D8DE\" d=\"M22.603 4.667H9.269v20h13.334v-20z\"/><path fill=\"#3F4450\" d=\"M15.936 29.333a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z\"/><path fill=\"#3F4450\" d=\"M23.933 32h-16a2 2 0 01-2-2V2a1.999 1.999 0 012-2h16a1.999 1.999 0 012 2v28a1.998 1.998 0 01-2 2zm-16-30.667A.664.664 0 007.267 2v28a.665.665 0 00.666.667h16A.664.664 0 0024.6 30V2a.665.665 0 00-.667-.667h-16z\"/><path fill=\"#3F4450\" d=\"M23.267 25.333H8.6V4h14.667v21.333zM9.933 24h12V5.333h-12V24z\"/><path stroke=\"#3F4450\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12.603 16.222L14.514 18l4.755-6.667\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "none"
  }
};